module.exports = __webpack_public_path__ + "img/muhyiddin_mouth.d8939160.jpg";